import { render, staticRenderFns } from "./courseTaskPartner.vue?vue&type=template&id=15d771a8&scoped=true"
import script from "./courseTaskPartner.vue?vue&type=script&lang=js"
export * from "./courseTaskPartner.vue?vue&type=script&lang=js"
import style0 from "./courseTaskPartner.vue?vue&type=style&index=0&id=15d771a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d771a8",
  null
  
)

export default component.exports